module.exports = __webpack_public_path__ + "img/32400.0afd3c2d.jpg";